// bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../bindings/bao-searcher";
import "./../bindings/bao-date-time-box";
import "./../bindings/bao-date-time-picker";
import "./../services/bao-router";
import * as $ from "jquery";
import BaseViewModel from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import * as moment from "moment";
import TabController from "./../factories/tab-controller";
import baoRouter from "./../services/bao-router";
import BaoDialog from "./../factories/bao-dialog";
import DailyShiftPlanCopyDialog from "./dialogs/daily-shift-plan-copy-dialog";
import DailyShiftPlanOverviewDialog from "./dialogs/daily-shift-plan-overview-dialog";
export interface ShiftPlanQualificationModel {
    CIPersonId: KnockoutObservable<string>;
    PersonFullName: KnockoutObservable<string>;
    WorkplaceId: KnockoutObservable<string>;
    Workplace: KnockoutObservable<any>;
    WorkplaceName: KnockoutObservable<string>;
    IsInTraining: KnockoutObservable<boolean>;
    IsAdditionalResource: KnockoutObservable<boolean>;
    Remark: KnockoutObservable<string>;
    ShiftTypeId: KnockoutObservable<string>;
    ShiftbookId: KnockoutObservable<string>;
    ShiftGroupId: KnockoutObservable<string>;
    ValidDateJs: KnockoutObservable<string>;
    IsNew: KnockoutObservable<boolean>;
    Person: KnockoutObservable<any>;
    IsPersonIncorrect: KnockoutObservable<boolean>;
    IsWrongQualification: KnockoutObservable<boolean>;
    IsAlreadyAssigned: KnockoutObservable<boolean>;
    IsAbsent: KnockoutObservable<boolean>;
    QualificationIdsByWorkplace: KnockoutObservableArray<string>;
    QualificationIdsByPerson: KnockoutObservableArray<string>;
}
class DailyShiftPlan extends BaseViewModel {
    constructor(tabPage: TabPage) {
        super(tabPage);
        this.ShiftType.subscribe((val) => {
            if (!(val)) {
                return;
            }
            this.ShiftTypeName(val.Name);
            this.ShiftStartTime(val.StartTime);
            this.ShiftDuration(val.DurationHtml);
        });
        this.ShiftTypeId.subscribe(() => {
            if (this.loadDataOk) {
                this.loadData(this.ValidDate(), this.ShiftGroupId(), this.ShiftbookId());
            }
        });
        this.ShiftBook.subscribe((val) => {
            if (!(val)) {
                return;
            }

            this.ShiftPlanQualificationCollection([]);

            this.ShiftBookName(val.Name);
        });
        this.ShiftbookId.subscribe(() => {
            this.clearAfterSelectedShiftbook();
        });
        this.ShiftGroup.subscribe((val) => {
            if ((val)) {
                this.ShiftGroupName(val.Name);
            }
            return;
        });
        this.ShiftGroupId.subscribe(() => {
            if (this.loadDataOk) {
                this.loadData(this.ValidDate(), this.ShiftGroupId(), this.ShiftbookId());
            }
        });
        this.ValidDate.subscribe(() => {
            if (this.loadDataOk) {
                this.loadData(this.ValidDate(), this.ShiftGroupId(), this.ShiftbookId());
            }
        });
        this.AvailableEmployeeCollection.subscribe(() => {
            this.setAvailableEmployeeCollectionToShow();
        });
        this.TabPage.MenuEvents.push(this.Menu.registerEvent((btnClicked) => {
            if (this.TabPage.IsActiveTab() !== true) {
                return;
            }
            switch (btnClicked.ActionKey()) {
                case "DailyShiftPlanSave":
                    this.saveData();
                    break;
                case "DailyShiftPlanRefresh":
                    this.loadData(this.ValidDate(), this.ShiftGroupId(), this.ShiftbookId());
                    break;
                case "DailyShiftPlanCopy":
                    this.openCopyDialog();
                    break;
                case "DailyShiftPlanPreviousShift":
                    this.changeToPreviousShift();
                    break;
                case "DailyShiftPlanNextShift":
                    this.changeToNextShift();
                    break;
                case "DailyShiftPlanOverview":
                    this.openOverviewDialog();
                    break;
            }
        }));
        this.TabPage.UrlData.subscribe(data => {
            if (data.shiftGroupId === this.ShiftGroupId() && data.shiftbookId === this.ShiftbookId() && data.shiftTypeId === this.ShiftTypeId()) {
                return;
            }
            if (!this.ShiftGroupId() && !this.ShiftbookId()){
                this.loadMetaData();
            }            
        });
    }
    CompleteCheck() {
        return true;
    }
    Subscriptions: KnockoutSubscription[] = [];
    loadDataOk: boolean = true;
    ValidDate = ko.observable<string>();
    ShiftTypeId = ko.observable<string>();
    ShiftTypeName = ko.observable<string>();
    ShiftType = ko.observable<any>();
    ShiftbookId = ko.observable<string>();
    ShiftBook = ko.observable<any>();
    ShiftBookName = ko.observable<string>();
    ShiftStartTime = ko.observable<string>();
    ShiftDuration = ko.observable<string>();
    ;
    ShiftGroupName = ko.observable<string>();
    ShiftGroupId = ko.observable<string>();
    ShiftGroup = ko.observable<any>();
    CIPersonId = ko.observable<string>();
    Person = ko.observable<any>();
    Workplace = ko.observable<any>();
    IsInTraining = ko.observable<boolean>(false);
    DefaultShiftGroupId = ko.observable<string>();
    ShiftPlanQualificationCollection = ko.observableArray<ShiftPlanQualificationModel>([]);
    IsLoading = ko.observable<boolean>(false);
    IsFreeShift = ko.observable<boolean>(false);
    AvailableEmployeeCollection = ko.observableArray([]);
    AvailableEmployeeCollectionToShow = ko.observableArray([]);
    AbsentEmployeeCollection = ko.observableArray([]);
    DateTimeBoxValidDate: Bindings.baoDateTimeBox = {
        value: this.ValidDate,
        mode: 'date',
        culture: Bao.Session.Language.Symbol()
    };
    DatePickerValidDate: Bindings.baoDateTimePicker = {
        mode: 'date'
    };
    SearcherShiftType: Bindings.baoSearcher = {
        ObjectId: this.ShiftTypeId,
        ObjectValue: 'Name',
        SearchType: 'ShiftType',
        SelectedItem: this.ShiftType,
        AutoComplete: true,
        AutoSearch: true,
        CustomFilter: { ExcludeNoDuration: true, ShiftbookId: this.ShiftbookId }
    };
    SearcherShiftBook: Bindings.baoSearcher = {
        ObjectId: this.ShiftbookId,
        ObjectValue: 'Name',
        SearchType: 'ShiftBook',
        SelectedItem: this.ShiftBook,
        AutoComplete: true,
        AutoSearch: true,
        CustomFilter: { CurrentUserHasIsInShiftplanAllowed: true }
    };
    SearcherShiftGroup: Bindings.baoSearcher = {
        ObjectId: this.ShiftGroupId,
        ObjectValue: 'Name',
        SearchType: 'ShiftGroup',
        SelectedItem: this.ShiftGroup,
        AutoComplete: true,
        AutoSearch: true,
        CustomFilter: { ActiveForShiftplan: true, ShiftbookId: this.ShiftbookId }
    };
    InitUrl(): string {
        return "";
    }
    init(): JQueryPromise<void> {
        return $.when(super.init(), this.loadMetaData());
    }
    addRow() {
        let model: ShiftPlanQualificationModel = {
            CIPersonId: ko.observable<string>(),
            PersonFullName: ko.observable<string>(),
            WorkplaceId: ko.observable<string>(),
            Workplace: ko.observable<any>(),
            WorkplaceName: ko.observable<string>(),
            IsInTraining: ko.observable<boolean>(false),
            IsAdditionalResource: ko.observable<boolean>(true),
            Remark: ko.observable<string>(),
            ShiftTypeId: ko.observable<string>(this.ShiftTypeId()),
            ShiftbookId: ko.observable<string>(this.ShiftbookId()),
            ShiftGroupId: ko.observable<string>(),
            ValidDateJs: ko.observable<string>(this.ValidDate()),
            IsNew: ko.observable<boolean>(true),
            Person: ko.observable<any>(),
            IsPersonIncorrect: ko.observable<boolean>(),
            IsWrongQualification: ko.observable<boolean>(),
            IsAlreadyAssigned: ko.observable<boolean>(),
            IsAbsent: ko.observable<boolean>(),
            QualificationIdsByPerson: ko.observableArray<string>(),
            QualificationIdsByWorkplace: ko.observableArray<string>()
        };
        this.initModel(model);
        this.ShiftPlanQualificationCollection.push(model);
    }
    addRowTraining() {
        let model: ShiftPlanQualificationModel = {
            CIPersonId: ko.observable<string>(),
            PersonFullName: ko.observable<string>(),
            WorkplaceId: ko.observable<string>(),
            Workplace: ko.observable<any>(),
            WorkplaceName: ko.observable<string>(),
            IsInTraining: ko.observable<boolean>(true),
            IsAdditionalResource: ko.observable<boolean>(false),
            Remark: ko.observable<string>(),
            ShiftTypeId: ko.observable<string>(this.ShiftTypeId()),
            ShiftbookId: ko.observable<string>(this.ShiftbookId()),
            ShiftGroupId: ko.observable<string>(),
            ValidDateJs: ko.observable<string>(this.ValidDate()),
            IsNew: ko.observable<boolean>(true),
            Person: ko.observable<any>(),
            IsPersonIncorrect: ko.observable<boolean>(),
            IsWrongQualification: ko.observable<boolean>(),
            IsAlreadyAssigned: ko.observable<boolean>(),
            IsAbsent: ko.observable<boolean>(),
            QualificationIdsByPerson: ko.observableArray<string>(),
            QualificationIdsByWorkplace: ko.observableArray<string>()
        };
        this.initModel(model);
        this.ShiftPlanQualificationCollection.push(model);
    }
    removeRow(model: ShiftPlanQualificationModel) {
        this.ShiftPlanQualificationCollection.remove(model);
        this.setAvailableEmployeeCollectionToShow();
    }
    private loadMetaData() {
        return Bao.post("ShiftSchedule/DailyPlanMetaData", JSON.stringify({
                shiftGroupId: this.TabPage.UrlData().shiftGroupId,
                shiftbookId: this.TabPage.UrlData().shiftbookId,
                shiftTypeId: this.TabPage.UrlData().shiftTypeId,
                date: this.TabPage.UrlData().date
            }))
            .done((result: {
                CurrentDate: string;
                CurrentShift: any;
                CurrentShiftBook: any;
                CurrentShiftGroup: any;
                ShiftCollection: any[];
                TabTitle: string;
            }) => {
                this.TabPage.Title(result.TabTitle);
                this.ValidDate(result.CurrentDate);
                if (result.CurrentShiftBook !== null) {
                    this.ShiftBook(result.CurrentShiftBook);
                    this.ShiftbookId(result.CurrentShiftBook.ShiftbookId);

                    if (result.CurrentShift !== null) {
                        this.ShiftType(result.CurrentShift);
                        this.ShiftTypeId(result.CurrentShift.ShiftTypeId);
                    }
                    if (result.CurrentShiftGroup !== null) {
                        this.ShiftGroup(result.CurrentShiftGroup);
                        this.ShiftGroupId(result.CurrentShiftGroup.ShiftGroupId);
                    }

                    if (!result.CurrentShift.Duration) {
                        this.IsFreeShift(true);
                    }
                    else {
                        this.IsFreeShift(false);
                    }
                }       
            });
    }
    private loadData(validDate: string, shiftGroupId: string, shiftbookId: string) {
        if (!this.IsLoading() && validDate && shiftGroupId && shiftbookId) {
            this.disposeSubscriptions();
            this.ShiftPlanQualificationCollection([]);
            this.AvailableEmployeeCollection([]);
            this.AbsentEmployeeCollection([]);
            this.IsLoading(true);
            this.TabPage.IsLoading(true);
            return Bao.post("ShiftSchedule/DailyPlanData", JSON.stringify({
                shiftGroupId: shiftGroupId,
                shiftbookId: shiftbookId,
                date: validDate
            })).done(result => {
                result.ShiftPlanQualificationCollection.forEach(model => {
                    model["Person"] = ko.observable<any>();
                    model["IsPersonIncorrect"] = ko.observable<boolean>();
                    model["Workplace"] = ko.observable<any>();
                    model["IsWrongQualification"] = ko.observable<boolean>();
                    model["IsAlreadyAssigned"] = ko.observable<boolean>();
                    model["IsAbsent"] = ko.observable<boolean>();
                });
                this.disposeSubscriptions();
                if (!result.ShiftType.Duration) {
                    this.IsFreeShift(true);
                }
                else {
                    this.IsFreeShift(false);
                }
                ko.map.fromJS(result, this, this.TabPage.DirtyFlag);
                // hack, each model.init requires a server call
                // initDefArray stores each ajax-call-deferred 
                let initDefArray = [];
                this.ShiftPlanQualificationCollection().forEach(model => initDefArray.push(this.initModel(model)));
                // when all initModel-calls are finished...
                $.when(...initDefArray)
                    .then(() => {
                    this.TabPage.DirtyFlag(false);
                    this.TabPage.IsLoading(false);
                    this.IsLoading(false);
                });
            });
        }
    }
    private openCopyDialog() {
        if (this.ShiftTypeId() && this.ValidDate()) {
            this.TabPage.IsLoading(true);
            return Bao.post("ShiftSchedule/DailyPlanCopyDialog")
                .done(result => {
                let dailyShiftPlanCopyDialog = new BaoDialog(Bao.Session.GetMessage("msgCopyDailyShiftPlan"), result.Template);
                dailyShiftPlanCopyDialog.ViewModel(new DailyShiftPlanCopyDialog(this.ShiftGroupId(), this.ShiftGroupName()));
                dailyShiftPlanCopyDialog.Buttons([
                    new BaoDialog.ButtonFactory(dailyShiftPlanCopyDialog, Bao.Session.GetMessage("msgOk"), () => {
                        if ((<DailyShiftPlanCopyDialog>dailyShiftPlanCopyDialog.ViewModel()).FromDate() && (<DailyShiftPlanCopyDialog>dailyShiftPlanCopyDialog.ViewModel()).ToDate()) {
                            this.copyData(dailyShiftPlanCopyDialog);
                            //let warningDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgCopyDailyShiftPlanWarning"), "yesno");
                            //warningDialog.DialogResult.subscribe(() => {
                            //    if (warningDialog.DialogResult()) {
                            //        this.copyData(dailyShiftPlanCopyDialog);
                            //    }
                            //});
                        }
                        else {
                            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                        }
                    }),
                    new BaoDialog.ButtonFactory(dailyShiftPlanCopyDialog, Bao.Session.GetMessage("msgCancel"), () => {
                        dailyShiftPlanCopyDialog.Close();
                    })
                ]);
                dailyShiftPlanCopyDialog.Width("500px");
                dailyShiftPlanCopyDialog.Open();
                this.TabPage.IsLoading(false);
            });
        }
    }
    private copyData(dailyShiftPlanCopyDialog: BaoDialog) {
        this.TabPage.IsLoading(true);
        Bao.post("ShiftSchedule/CopyDailyPlanData", JSON.stringify({
            shiftbookId: this.ShiftbookId(),
            shiftGroupId: this.ShiftGroupId(),
            sourceShiftTypeId: this.ShiftTypeId(),
            sourceDate: this.ValidDate(),
            fromDate: (<DailyShiftPlanCopyDialog>dailyShiftPlanCopyDialog.ViewModel()).FromDate(),
            toDate: (<DailyShiftPlanCopyDialog>dailyShiftPlanCopyDialog.ViewModel()).ToDate(),
            overwriteTarget: (<DailyShiftPlanCopyDialog>dailyShiftPlanCopyDialog.ViewModel()).OverwriteTarget()
        })).done(() => {
            dailyShiftPlanCopyDialog.Close();
        }).always(result => {
            this.TabPage.IsLoading(false);
        });
    }
    private saveData() {
        if (this.ShiftTypeId() && this.ValidDate() && this.ShiftbookId()) {
            this.TabPage.IsLoading(true);
            this.ShiftPlanQualificationCollection().forEach(model => {
                delete model.Person;
                delete model.IsPersonIncorrect;
                delete model.IsWrongQualification;
                delete model.Workplace;
                delete model.IsAlreadyAssigned;
                delete model.IsAbsent;
            });
            return Bao.post("ShiftSchedule/SaveDailyPlanData", JSON.stringify({
                shiftPlanQualificationCollection: ko.map.toJS(this.ShiftPlanQualificationCollection),
                shiftTypeId: this.ShiftTypeId(),
                shiftBookId: this.ShiftbookId(),
                date: this.ValidDate()
            })).done(result => {
                if (!result.ValidData) {
                    new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgInvalidDailyShiftplanData"), "info");
                }
                this.loadData(this.ValidDate(), this.ShiftGroupId(), this.ShiftbookId());
            });
        }
    }
    private changeToPreviousShift() {
        this.TabPage.IsLoading(true);
        return Bao.post("ShiftSchedule/GetPreviousShift", JSON.stringify({
            shiftbookId: this.ShiftbookId(),
            shiftGroupId: this.ShiftGroupId(),
            currentDateJs: this.ValidDate()
        })).done(result => {
            if (result.Shift != null) {
                this.loadDataOk = false;
                this.ShiftType(result.Shift);
                this.ShiftTypeId(result.Shift.ShiftTypeId);
                this.ValidDate(result.CurrentDate);
                this.loadDataOk = true;
                this.loadData(this.ValidDate(), this.ShiftGroupId(), this.ShiftbookId());
            }
            this.TabPage.IsLoading(false);
        });
    }
    private changeToNextShift() {
        this.TabPage.IsLoading(true);
        return Bao.post("ShiftSchedule/GetNextShift", JSON.stringify({
            shiftbookId: this.ShiftbookId(),
            shiftGroupId: this.ShiftGroupId(),
            currentDateJs: this.ValidDate()
        })).done(result => {
            if (result.Shift != null) {
                this.loadDataOk = false;
                this.ShiftType(result.Shift);
                this.ShiftTypeId(result.Shift.ShiftTypeId);
                this.ValidDate(result.CurrentDate);
                this.loadDataOk = true;
                this.loadData(this.ValidDate(), this.ShiftGroupId(), this.ShiftbookId());
            }
            this.TabPage.IsLoading(false);
        });
    }
    private openOverviewDialog() {
        if (this.ShiftTypeId() && this.ValidDate() && this.ShiftbookId()) {
            this.TabPage.IsLoading(true);
            return Bao.post("ShiftSchedule/DailyPlanOverviewDialog")
                .done(result => {
                let dailyShiftPlanOverviewDialog = new BaoDialog(Bao.Session.GetMessage("msgDailyShiftPlanOverview"), result.Template);
                dailyShiftPlanOverviewDialog.ViewModel(new DailyShiftPlanOverviewDialog(dailyShiftPlanOverviewDialog, this.TabPage, this.ValidDate(), this.ShiftbookId(), this.ShiftBookName()));
                dailyShiftPlanOverviewDialog.Buttons([
                    new BaoDialog.ButtonFactory(dailyShiftPlanOverviewDialog, Bao.Session.GetMessage("msgCancel"), () => {
                        dailyShiftPlanOverviewDialog.Close();
                    })
                ]);
                dailyShiftPlanOverviewDialog.Open();
                dailyShiftPlanOverviewDialog.DialogResult.subscribe(result => {
                    this.loadData(result.ValidDate, result.ShiftGroupId, result.ShiftbookId);
                    this.ValidDate(result.ValidDate);
                    this.ShiftTypeId(result.ShiftTypeId);
                    this.ShiftTypeName(result.ShiftTypeName);
                });
                this.TabPage.IsLoading(false);
            });
        }
    }
    private setAvailableEmployeeCollectionToShow() {
        var availableEmployeeCollectionToShow = [];
        this.AvailableEmployeeCollection().forEach(availableEmployee => {
            var found = false;
            for (var model of this.ShiftPlanQualificationCollection()) {
                if (model.CIPersonId() === availableEmployee.PersonId()) {
                    found = true;
                    break;
                }
            }
            if (!found) {
                availableEmployeeCollectionToShow.push(availableEmployee);
            }
        });
        this.AvailableEmployeeCollectionToShow(availableEmployeeCollectionToShow);
    }
    private initModel(model: ShiftPlanQualificationModel) {
        this.isAlreadyAssigned(model);
        let def = this.isAbsent(model);
        this.isPersonIncorrect(model);
        this.isWrongQualification(model);
        if (!model.QualificationIdsByPerson) {
            model.QualificationIdsByPerson([]);
        }
        if (!model.QualificationIdsByWorkplace) {
            model.QualificationIdsByWorkplace([]);
        }
        this.Subscriptions.push(model.CIPersonId.subscribe(() => {
            this.setAvailableEmployeeCollectionToShow();
            if (!model.CIPersonId()) {
                model.QualificationIdsByPerson([]);
                //model.IsInTraining(false);
            }
        }));
        this.Subscriptions.push(model.Person.subscribe(() => {
            this.isAlreadyAssigned(model);
            this.isAbsent(model);
            this.isPersonIncorrect(model);
            if (model.Person()) {
                model.ShiftGroupId(model.Person().ShiftGroupId);
                model.QualificationIdsByPerson(model.Person().QualificationIds);
            }
            this.isWrongQualification(model);
        }));
        this.Subscriptions.push(model.Workplace.subscribe(() => {
            if (model.Workplace()) {
                if (model.IsInTraining()) {
                    model.QualificationIdsByWorkplace([]);
                }
                else {
                    if (model.Workplace().QualificationIdsByWorkplace.length > 0) {
                        model.QualificationIdsByWorkplace(model.Workplace().QualificationIdsByWorkplace);
                    }
                    else {
                        model.QualificationIdsByWorkplace([]);
                    }
                }
            }
            else {
                model.QualificationIdsByWorkplace([]);
            }
            this.isWrongQualification(model);
        }));
        return def;
    }
    private isWrongQualification(model: ShiftPlanQualificationModel) {
        if (model.CIPersonId() && !model.IsPersonIncorrect() && model.QualificationIdsByPerson() && model.QualificationIdsByWorkplace()) {
            let allQualificationsMet = model.QualificationIdsByWorkplace().every(function (qualification) {
                return model.QualificationIdsByPerson().indexOf(qualification) >= 0;
            });
            if (allQualificationsMet) {
                model.IsWrongQualification(false);
                return;
            }
            if (!model.IsInTraining()) {
                model.IsWrongQualification(true);
            }
            return;
        }
        else {
            model.IsWrongQualification(false);
        }
    }
    private isPersonIncorrect(model: ShiftPlanQualificationModel) {
        if (model.CIPersonId()) {
            for (var absentEmployee of this.AbsentEmployeeCollection()) {
                if (model.CIPersonId() === absentEmployee.PersonId()) {
                    model.IsPersonIncorrect(true);
                    return;
                }
            }
            for (var availableEmployee of this.AvailableEmployeeCollection()) {
                if (model.CIPersonId() === availableEmployee.PersonId()) {
                    model.IsPersonIncorrect(false);
                    return;
                }
            }
        }
        model.IsPersonIncorrect(false);
    }
    private isAbsent(model: ShiftPlanQualificationModel) {
        if (model.CIPersonId()) {
            return Bao.post("ShiftSchedule/IsPersonAbsent", JSON.stringify({
                personId: model.CIPersonId(),
                date: this.ValidDate()
            })).then((result) => {
                model.IsAbsent(result);
            });
        }
    }
    private isAlreadyAssigned(model: ShiftPlanQualificationModel) {
        // check which personIDs are assigned more than once
        let singlePersonIds = [];
        let doublePersonIds = [];
        for (let i = 0; i < this.ShiftPlanQualificationCollection().length; i++) {
            if (singlePersonIds.indexOf(this.ShiftPlanQualificationCollection()[i].CIPersonId()) > -1) {
                if (doublePersonIds.indexOf(this.ShiftPlanQualificationCollection()[i].CIPersonId()) == -1) {
                    doublePersonIds.push(this.ShiftPlanQualificationCollection()[i].CIPersonId());
                }
            }
            else {
                singlePersonIds.push(this.ShiftPlanQualificationCollection()[i].CIPersonId());
            }
        }
        // set all persons that are assigned ONCE  to IsAlreadyAssigned(false)
        singlePersonIds.forEach((id) => {
            for (let i = 0; i < this.ShiftPlanQualificationCollection().length; i++) {
                if (this.ShiftPlanQualificationCollection()[i].CIPersonId() == id) {
                    this.ShiftPlanQualificationCollection()[i].IsAlreadyAssigned(false);
                }
            }
        });
        // set all persons that are assigned MORE than once to IsAlreadyAssigned(true)
        doublePersonIds.forEach((id) => {
            for (let i = 0; i < this.ShiftPlanQualificationCollection().length; i++) {
                if (this.ShiftPlanQualificationCollection()[i].CIPersonId() == id && this.ShiftPlanQualificationCollection()[i].CIPersonId() != null) {
                    this.ShiftPlanQualificationCollection()[i].IsAlreadyAssigned(true);
                }
            }
        });
    }
    private disposeSubscriptions() {
        this.Subscriptions.forEach(subscription => subscription.dispose());
        this.Subscriptions = [];
    }
    private clearAfterSelectedShiftbook() {
        this.ShiftGroup(null);
        this.ShiftGroupId(null);
        this.ShiftGroupName(null);
    }
    PermissionRefresh: KnockoutObservable<string> = ko.observable("na");
    PermissionSave: KnockoutObservable<string> = ko.observable("na");
    PermissionDelete: KnockoutObservable<string> = ko.observable("na");
    PermissionQRCode: KnockoutObservable<string> = ko.observable("na");
    // override to avoid this.UnlockUrl call
    BeforeClose(closeFn) {
        return closeFn();
    }
}
export default DailyShiftPlan;